import { render, staticRenderFns } from "./exam-start.vue?vue&type=template&id=28c2a909&scoped=true&"
import script from "./exam-start.vue?vue&type=script&lang=ts&"
export * from "./exam-start.vue?vue&type=script&lang=ts&"
import style0 from "./exam-start.vue?vue&type=style&index=0&id=28c2a909&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "28c2a909",
  null
  
)

export default component.exports